export function getClassList(classList: (string | Record<string, boolean>)[]) {
  return classList
    .map(item => {
      let itemClassList = ''

      if (typeof item === 'object') {
        Object.entries(item).map(([className, value]) => {
          if (value) {
            itemClassList += className
          }
        })
        return itemClassList
      }

      return item
    })
    .join(' ')
}
